import type { Pagination } from 'models';
import { generateQueryKey } from 'query';
import type { GivingsListFilter } from '../types';

type GivingsParams = {
  filter?: Partial<GivingsListFilter>;
  pagination?: Partial<Pagination>;
};

const givingsQueryKey = 'givings';

export const getGivingsQueryKey = ({ filter = {}, pagination = {} }: GivingsParams) =>
  generateQueryKey([givingsQueryKey, { filter, pagination }]);

export const getGivingsInfiniteQueryKey = (params: GivingsParams = {}) =>
  generateQueryKey([...getGivingsQueryKey(params), 'infinite']);

export const getGivingDetailQueryKey = ({ givingId, view }: { givingId: string; view: 'internal' | 'public' }) => [
  givingsQueryKey,
  givingId,
  view,
];
